import React, { Component } from 'react'
import Thin from 'components/layout/Thin'
import TrackForm from 'components/Form/Track'
import Spacer from 'components/misc/Spacer'
import styled from 'styled-components'
import { body2 } from 'styles/mixins/textstyles'
import PoweredByRoadie from 'components/misc/PoweredByRoadieBadge'
import { ExternalLink } from 'components/layout/links'

const FooterLink = styled(ExternalLink)`
  margin: 0 .2rem;
  font-weight: 700;

  &:not(:first-child)::before {
    content: "//";
    color: ${props => props.theme.colors.greyLight};
    margin-right: .4rem;
  }
`

const Footer = styled.footer`
  ${props => body2(props.theme.colors.black, 'medium')}

  text-align: center;
  margin: 9.6rem 0 3.2rem;
`

const Copyright = styled.div`
  margin-top: .4rem;
`

export default class Track extends Component {
  render() {
    return (
      <>
        <Spacer height="6.4rem" />
        <Thin>
          <TrackForm themeName={this.props.themeName} />
        </Thin>


        <Spacer height="36rem" />
        <Footer>
          {this.props.themeName && this.props.themeName !== 'roadie' ? (
            <PoweredByRoadie />
          ) : (
            <>
              <div>
                <FooterLink href="https://support.roadie.com">Help</FooterLink>
                <FooterLink href="https://www.roadie.com/privacy">Privacy</FooterLink>
                <FooterLink href="https://www.roadie.com/terms">Terms</FooterLink>
              </div>
              <Copyright>©{new Date().getFullYear()} Roadie, Inc. All rights reserved</Copyright>
            </>
          )}
        </Footer>
      </>
    )
  }
}